import { render, staticRenderFns } from "./ModalSucesso.vue?vue&type=template&id=33687ff2"
import script from "./ModalSucesso.vue?vue&type=script&lang=js"
export * from "./ModalSucesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports